import type { Tournament } from '@airmail/engine';

/**
 * Filter über der Turnierliste: Alle · Geplant · Läuft · Beendet — für die
 * Turniere auf dem Gerät **und** die im Konto („In der Cloud“), darum hier
 * und nicht in der Seite (docs/notes/turnierliste.md). „Beendet“ fasst
 * `finished` und `archived` zusammen — für die Liste ist beides vorbei.
 *
 * `status` darf fehlen: Cloud-Turniere von vor dem Stand-Feld kennt der
 * Server nicht genau, bis der nächste Push ihn setzt. Die stehen nur unter
 * „Alle“ und tragen in der Zeile „Stand unbekannt“.
 */
export type Filter = 'alle' | 'geplant' | 'laeuft' | 'beendet';
export type TurnierStatus = Tournament['status'];
export const FILTER_KEY = 'airmail.listFilter';
export const FILTER: { key: Filter; label: string; leer?: string; leerCloud?: string; trifft: (s: TurnierStatus | undefined) => boolean }[] = [
  { key: 'alle', label: 'Alle', trifft: () => true },
  { key: 'geplant', label: 'Geplant', leer: 'Keine geplanten Turniere', leerCloud: 'Keine geplanten Turniere in der Cloud', trifft: (s) => s === 'draft' },
  { key: 'laeuft', label: 'Läuft', leer: 'Keine laufenden Turniere', leerCloud: 'Keine laufenden Turniere in der Cloud', trifft: (s) => s === 'running' },
  { key: 'beendet', label: 'Beendet', leer: 'Keine beendeten Turniere', leerCloud: 'Keine beendeten Turniere in der Cloud', trifft: (s) => s === 'finished' || s === 'archived' },
];
export function filterEintrag(f: Filter): (typeof FILTER)[number] {
  return FILTER.find((x) => x.key === f) ?? FILTER[0]!;
}
export function gemerkterFilter(): Filter {
  try {
    const v = localStorage.getItem(FILTER_KEY);
    return FILTER.some((f) => f.key === v) ? (v as Filter) : 'alle';
  } catch {
    return 'alle';
  }
}
export function merkeFilter(f: Filter): void {
  try {
    localStorage.setItem(FILTER_KEY, f);
  } catch {
    /* egal */
  }
}

/** Beschriftung der Status-Pille — in der Liste, im Start und in der Kopfzeile */
export function statusLabel(s: TurnierStatus): string {
  return { draft: 'Geplant', running: 'Läuft', finished: 'Beendet', archived: 'Archiv' }[s];
}
